import { Typography, Box } from '@mui/material';
import FileDropArea from '../../Atoms/FileDropArea';

interface AssetSelectionStepProps {
  file: File | null;
  onFileSelect: (file: File | null) => void;
}

export const AssetSelectionStep = ({ file, onFileSelect }: AssetSelectionStepProps) => {
  const handleFileDrop = (files: File[]) => {
    const xlsx = files.find((f) => f.name.endsWith('.xlsx'));
    onFileSelect(xlsx || null);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="body2"
        sx={{ mb: 2 }}>
        Upload an Excel (.xlsx) file containing one column of Salesforce Asset upstack IDs to migrate.
      </Typography>
      <FileDropArea
        instructions="Drag and drop your .xlsx file here"
        subInstructions="Only .xlsx files are accepted"
        buttonText="Browse Files"
        allowedFileTypes={['.xlsx']}
        onFileDrop={handleFileDrop}
      />
      {file && (
        <Typography
          variant="body2"
          sx={{ mt: 1, color: 'success.main' }}
          data-testid="selected-file-name">
          Selected: {file.name}
        </Typography>
      )}
    </Box>
  );
};
